import React from "react";
import { Button } from "react-bootstrap";
import { bootstrapUtils } from "react-bootstrap/lib/utils";

bootstrapUtils.addStyle(Button, "grey");

function UiButton(props) {
  const { onClick, disabled, children, className } = props;

  const style = disabled === true ? "grey" : "primary";
  const btnClassName = className
    ? `btn-pm-decisions-button ${className}`
    : "btn-pm-decisions-button";

  return (
    <Button
      className={btnClassName}
      bsStyle={style}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </Button>
  );
}

export default UiButton;



// WEBPACK FOOTER //
// ./src/components/pm/decisions/ui-button.js